import { render, staticRenderFns } from "./TemplateFormRulesWidget.vue?vue&type=template&id=4fecb450&scoped=true"
import script from "./TemplateFormRulesWidget.vue?vue&type=script&lang=js"
export * from "./TemplateFormRulesWidget.vue?vue&type=script&lang=js"
import style0 from "./TemplateFormRulesWidget.vue?vue&type=style&index=0&id=4fecb450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fecb450",
  null
  
)

export default component.exports